<template>
    <div class="intro-container">
        <!-- <div class="title-tab flex items-center justify-center">
            <i class="el-icon-arrow-left" style="color: #FFFFFF;font-size: 20px;"></i>
            <i class="el-icon-arrow-left" style="color: #FFFFFF;font-size: 20px;"></i>
            <i class="el-icon-arrow-left" style="color: #FFFFFF;font-size: 20px;"></i>
            <div class="text-white title-container">笔、面试专业命题 制卷分装 保密押运</div>
            <i class="el-icon-arrow-right" style="color: #FFFFFF;font-size: 20px;"></i>
            <i class="el-icon-arrow-right" style="color: #FFFFFF;font-size: 20px;"></i>
            <i class="el-icon-arrow-right" style="color: #FFFFFF;font-size: 20px;"></i>
        </div> -->
        <div class="flex font-18 text-000 intro-content">
            <el-image class="image" :src="introImg" />
            <div class="flex-1" style="line-height: 36px;">
                <div style=" text-align: justify;text-indent:36px;letter-spacing: 1px;">
                    云南省高校人才市场，坐落于素以“春城”著称的昆明,隶属于云南大学，于1998年6月1
                    在昆明挂牌成立，迄今为止已经为客户提供了23年的优质服务，主要经营:为政府，企事业单位提供人才测评、考试服务，高等院校人才、科技人才等的咨询、培训、中介服务及相关经济、人才信息的交流、发布等。
                </div>
                <div style=" text-align: justify;text-indent:36px;letter-spacing: 1px;">
                    近年来严格的考务组织管理，强大的考试信息采集及数据处理能力，扩大了在业内外的影响，不断为政府指令性招考及各大国企、事业单位等提供了专业的考试考务服务工作。市场有云南省保密委核发的绝密级保密室，全员通过并取得保密工作证。配备了专业的考试管理和技术人员，拥有自主知识产权的题库系统、阅卷系统，拥有自己的命题、阅卷、考试基地和办公场所，考试技术指导为考试服务工作提供了强有力的保障。
                </div>
                <div style=" text-align: justify;text-indent:36px;letter-spacing: 1px;">
                    高校人才市场本着以服务用人部门、服务社会、服务考生为己任，以公开、公平、公正为基本原则，以实现科学考试、公平考试、安全考试为总目标，致力于加强命题技术、考务制度体系、考试信息化、考试文化等考试核心能力建设，较好地完成了数千科次的专业技术人员资格考试、数百万人员参加的遴选考试和事业单位公开招聘、以及烟草行业、公安系统、武警部队、军人事务厅、环保厅、教体局、文旅局、各产业园区、团（市、区、县）委等政府机构，各高校、企、事业单位的公开招聘工作人员、文职辅警、专项教师、村官、三支一扶、西部志愿者、社区工作者等考试工作，涉及覆盖面广泛，零失误高效率，专业的考务组织树立了云南省人事考试的品牌和权威。
                </div>
                <div style=" text-align: justify;text-indent:36px;letter-spacing: 1px;">
                    今后，我们仍将继续努力加强自身建设，努力加强考试新技术、新模式、新题型的研发，加强考试信息化建设，努力做好每一项考试，为人才队伍建设做出我们的贡献。
                </div>
            </div>
        </div>
        <div class="picture">
            <!-- <div class="divv" style="width: 30%;">
                <div class="item">
                    <el-image class="el-image" style="width: 100%;" :src="picture1" :preview-src-list="[picture1]" />
                </div>
                <div class="m-t-20 font-18 text-000 text-center" style="height: 48px;">云南省高校人才市场营业执照</div>
            </div> -->
            <div class="divv" style="width: 30%;">
                <div class="item">
                    <el-image class="el-image" style="width: 100%;" :src="picture2" :preview-src-list="[picture2]" />
                </div>
                <div class="m-t-20 font-18 text-000 text-center" style="height: 48px;">云南省高校人才市场人力资源服务许可证</div>

            </div>
            <div class="divv" style="width: 30%;">
                <div class="item">
                    <el-image class="el-image" style="width: 100%;" :src="picture3" :preview-src-list="[picture3]" />
                </div>
                <div class="m-t-20 font-18 text-000 text-center" style="height: 48px;">云南省高校人才市场保密资质</div>

            </div>
        </div>
    </div>
</template>

<script>
import introImg from '@/assets/image/home/introImg.jpg'
import picture1 from '@/assets/image/home/picture1.jpg'
import picture2 from '@/assets/image/home/picture2.jpg'
import picture3 from '@/assets/image/home/picture3.jpg'

export default {
    data() {
        return {
            introImg,
            picture1,
            picture2,
            picture3
        }
    }
}
</script>

<style lang="scss" scoped>
.title-tab {
    width: 85%;
    max-width: 1200px;
    height: 98px;
    background: url('@/assets/image/home/introBg.png');
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0 auto 80px;

    .title-container {
        margin: 0 50px;
        font-size: 26px;
    }
}

.intro-content {
    justify-content: space-between;
    margin-bottom: 90px;

    .image {
        width: 412px;
        margin: 10px 60px 10px 0;
        height: 595px;
    }
}

.picture {
    width: 100%;
    display: flex;
    justify-content: space-between;

    // grid-template-columns: repeat(3, 1fr);
    align-items: stretch;
    /* 默认值，可省略 */
    gap: 70px;

    .divv {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .item {
        width: 100%;
        flex: 1;
        // aspect-ratio: 4 / 3;
        /* 关键！所有图片容器高度一致 */
        // overflow: hidden;
        box-sizing: border-box;
        padding: 35px 30px 50px;
        background: linear-gradient(0deg, rgba(149, 149, 149, 0.1) 0%, rgba(220, 220, 220, 0.1) 100%);
        border-top: 10px solid #B91D22;

        .el-image {
            width: 100%;
            // height: 100%;
            // object-fit: cover;
            /* 图片按比例填充，可能裁剪边缘 */
            /* 如果希望完整显示不变形，可用 object-fit: contain */
        }
    }
}

/* 平板端适配 */
@media screen and (max-width: 1024px) {
    .title-tab {
        width: 100%;
        .title-container {
            font-size: 24px;
            // margin: 0 auto;
        }
    }
    .intro-content {
        box-sizing: border-box;
        // padding: 0 50px;
        flex-direction: column;
        align-items: center;
        margin-bottom: 50px;

        .image {
            width: 100%;
            height: auto;
            margin: 0 auto 50px;
            // height: 300px;
        }
    }
}

@media screen and (max-width: 768px) {
    .title-tab {
        height: 68px !important;
        width: 100%;
        background: url('@/assets/image/home/introBg.png');
        background-size: 100% 100%;
        background-position: center;
        margin: 0 auto 30px;
        i {
            display: none;
        }

        .title-container {
            height: auto !important;
            font-size: 20px !important;
            text-align: center;
        }
    }
    .intro-content {
        justify-content: center;
    }
    .image {
        width: 100%;
        height: auto;
        margin: 0 auto 30px;
    }
    .picture {
        margin-bottom: 30px;
    }
}
</style>